import classNames from "classnames";
import Card from "@/components/UI/Card/Card";
import { JobHistory } from "@webmonitoring/vp-common/Types/Apis/JobGet";
import { toRelativeDate } from "@/utils/date";

type NoChangesDetectedCardProps = {
  historyItem: JobHistory;
  page: any;
  section: any;
};

const NoChangesDetectedCard = ({ historyItem, page, section }: NoChangesDetectedCardProps) => {
  return (
    <Card className="flex w-full items-center border-vpBlue-300 p-8" color="primary200" rounded="medium">
      <div
        className={classNames(
          "absolute -left-[15px] z-10 border-y-[15px] border-l-0 border-r-[15px] border-solid border-y-transparent border-r-vpBlue-300"
        )}
      />
      <div
        className={classNames(
          "absolute -left-[14px] z-10 border-y-[15px] border-l-0 border-r-[15px] border-solid border-y-transparent border-r-vpBlue-200"
        )}
      />
      <div className="flex w-full">
        <div className="flex flex-1 items-center gap-1">
          <div className="text-sm font-bold uppercase tracking-tight">{section?.Check}</div>
          <div className="text-sm uppercase">
            {toRelativeDate({
              date: new Date(historyItem.created).getTime(),
              locale: page?.attributes?.locale,
            })}
          </div>
        </div>
        <div className="text-sm uppercase">{section?.NoChangesDetected}</div>
      </div>
    </Card>
  );
};

export default NoChangesDetectedCard;
